import script from "./ViewPVMemosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewPVMemosPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewPVMemosPage.vue?vue&type=style&index=0&id=ca36d50a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca36d50a"]])

export default __exports__